"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var singleSpa = require("single-spa");
function hashPrefix(prefix) {
    return function (location) {
        return location.hash.startsWith("#" + prefix);
    };
}
exports.hashPrefix = hashPrefix;
// export async function loadApp(name, hash, appURL) {
//     register the app with singleSPA and pass a reference to the store of the app as well as a reference to the globalEventDistributor
//     singleSpa.registerApplication(name, () => SystemJS.import(appURL), hashPrefix(hash), null);
// }
// TODO: VERIFY LOAD STORE TO DISTRIBUTE EVENT WITH THE APPS
function loadApp(name, hash, appURL, storeURL, globalEventDistributor) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var storeModule, customProps, _a, e_1;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    storeModule = {}, customProps = { globalEventDistributor: globalEventDistributor };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 5, , 6]);
                    if (!storeURL) return [3 /*break*/, 3];
                    return [4 /*yield*/, SystemJS.import(storeURL)];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = { storeInstance: null };
                    _b.label = 4;
                case 4:
                    storeModule = _a;
                    return [3 /*break*/, 6];
                case 5:
                    e_1 = _b.sent();
                    console.log("Could not load store of app " + name + ".", e_1);
                    return [3 /*break*/, 6];
                case 6:
                    if (storeModule.storeInstance && globalEventDistributor) {
                        // add a reference of the store to the customProps
                        customProps.store = storeModule.storeInstance;
                        // register the store with the globalEventDistributor
                        globalEventDistributor.registerStore(storeModule.storeInstance);
                    }
                    singleSpa.registerApplication(name, function () { return System.import(appURL); }, hashPrefix(hash), customProps);
                    return [2 /*return*/];
            }
        });
    });
}
exports.loadApp = loadApp;
//# sourceMappingURL=helper.js.map